<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

        <config-title-hang>
          <span slot="config_title_hang_ele2">所有的场景</span>
          <input slot="config_title_hang_ele8" type="text" placeholder="快速搜索" v-model="scerchValue" />
        </config-title-hang>

        <!-- 服务器返回的所有场景列表 -->
        <config-hang
          v-for="(value, index) in serveSceneListData"
          :key="index"
          @click.native="selectSceneBtnHandle(value)"
          :selectState="OneSceneObjectinfo.sceneId === value.sceneId"
        >
          <span slot="config_hang_ele2">{{ value.sceneName }}({{ value.regionName }})</span>
          <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
          <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
        </config-hang>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import { mediumslateblue } from "color-name";

export default {
  data() {
    return {
      serveSceneListData: [
        ///服务器返回的所有场景信息的数据
      ],
      serveSceneListDataBack: [
        //搜索使用
      ],
      scerchValue: "", // 搜索使用
      ServeOneObjectinfo: {
        ////一个对象的信息
      },
      OneSceneObjectinfo: {
        ///选中一个的场景信息
        sceneId: "",
        sceneName: ""
      }
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    selectSceneBtnHandle(value) {
      console.log("111111");
      this.OneSceneObjectinfo.sceneId = value.sceneId;
      this.OneSceneObjectinfo.sceneName = value.sceneName;
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了

      if (this.$route.query.type === "022config") {
        if (this.OneSceneObjectinfo.sceneId === "") {
          this.$toast("请至少选择一个场景！");
          return;
        }
        this.ServeOneObjectinfo.businessId4 = this.OneSceneObjectinfo.sceneId; ///拿到回显的场景ID
        this.ServeOneObjectinfo.businessId4Desc = this.OneSceneObjectinfo.sceneName; ///拿到回显的场景名字
      } else if (this.$route.query.type === "gt019config") {
        this.ServeOneObjectinfo.sceneIdGt = this.OneSceneObjectinfo.sceneId; ///拿到回显的场景ID
        this.ServeOneObjectinfo.sceneNameGt = this.OneSceneObjectinfo.sceneName; ///拿到回显的场景名字
      } else if (this.$route.query.type === "lt019config") {
        this.ServeOneObjectinfo.sceneIdLt = this.OneSceneObjectinfo.sceneId; ///拿到回显的场景ID
        this.ServeOneObjectinfo.sceneNameLt = this.OneSceneObjectinfo.sceneName; ///拿到回显的场景名字
      }
      this.$router.go(-1);
    },
        //业内数据搜索显示  //搜索使用
    seraceDataShow(charData) {
      if (
        this.serveSceneListData &&
        this.serveSceneListDataBack
      ) {
        //数据是合法存在的
        this.serveSceneListData = this.serveSceneListData.concat(
          this.serveSceneListDataBack
        );
        this.serveSceneListDataBack.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.serveSceneListData.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              (
                this.serveSceneListData[i].sceneName +
                this.serveSceneListData[i].regionName
              ).indexOf(charData) == -1
            ) {
              // && this.serveSceneListData[i].checked == false
              // 说明没有这个字符
              this.serveSceneListDataBack.push(
                this.serveSceneListData[i]
              );
              this.serveSceneListData.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.serveSceneListData);
      }
    }
  },
    watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  created() {
    console.log("created阶段");

    /// 获取场景列表(所有)接口，获取数据
    this.$request({
      method: "post",
      url: "/userScene/findUserSceneList",
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveSceneListData = res.data.data; ////拿到服务器返回的数据结果
          console.log(this.serveSceneListData);
          if (this.$route.query.type != "022config") {
            let noSceneData = {
              ////弄一个假数据，用来设置不绑定任何设备
              sceneId: "0",
              sceneName: "不绑定任何场景",
              regionName: ""
            };
            this.serveSceneListData.unshift(noSceneData);
          }
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });

    if (this.$route.query.type === "022config") {
      this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo; ////一个对象的地址信息拿过来
      this.OneSceneObjectinfo.sceneId = this.ServeOneObjectinfo.businessId4; ///拿到回显的场景ID
      this.OneSceneObjectinfo.sceneName = this.ServeOneObjectinfo.businessId4Desc; ///拿到回显的场景名字
    } else if (this.$route.query.type === "gt019config") {
      this.ServeOneObjectinfo = this.$store.state.configinfo.config019PageData; ////一个对象的地址信息拿过来
      this.OneSceneObjectinfo.sceneId = this.ServeOneObjectinfo.sceneIdGt; ///拿到回显的场景ID
      this.OneSceneObjectinfo.sceneName = this.ServeOneObjectinfo.sceneNameGt; ///拿到回显的场景名字
    } else if (this.$route.query.type === "lt019config") {
      this.ServeOneObjectinfo = this.$store.state.configinfo.config019PageData; ////一个对象的地址信息拿过来
      this.OneSceneObjectinfo.sceneId = this.ServeOneObjectinfo.sceneIdLt; ///拿到回显的场景ID
      this.OneSceneObjectinfo.sceneName = this.ServeOneObjectinfo.sceneNameLt; ///拿到回显的场景名字
    }

    // this.OneSceneinfo = this.$store.state.configinfo.OneSceneinfo;
    //需要把进来时的仓库的状态更新进来，根据页面进来的类型进行判断
    // if (this.$route.query.type === 1) {
    //   ///1代表是场景页面进来 选择区域的  进来的时候需要判断拉取数据
    //   this.OneSceneObjectinfo.regionName = this.$store.state.configinfo.OneSceneinfo.regionName;
    //   this.OneSceneObjectinfo.regionId = this.$store.state.configinfo.OneSceneinfo.regionId;
    // }else if(this.$route.query.type === 2){
    //   ///2代表是对象页面进来 选择区域的  进来的时候需要判断拉取数据
    //   this.OneSceneObjectinfo.regionName = this.$store.state.configinfo.ServeOneObjectinfo.regionName;
    //   this.OneSceneObjectinfo.regionId = this.$store.state.configinfo.ServeOneObjectinfo.regionId;
    // }
  }
};
</script>

<style></style>
